import React from "react";
import { Typography, Icon } from "@mui/material";
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';

import styles from "./styles";

const CountryItem = ({ country, isSelected, onClick, containerStyles }) => {
  return (
    <div style={{ ...styles.container, ...containerStyles }} onClick={onClick}>
      <Typography color="textPrimary" style={styles.country}>
        {country}
      </Typography>
      {isSelected && (
        <DoneOutlinedIcon sx={{ cursor: "pointer", color: "#0091DA", fontSize: 24 }}/>
      )}
    </div>
  );
};

export default CountryItem;
